import axios from 'axios';

import { BASE_URL } from '../../inc/constants';
import {fetchChartsStartedAction,fetchChartsSuccessAction} from './actions';
import { AppState } from '..';
import { logOut, handleCache } from '../base/functions';
import { Chart, ChartNode } from './types';
import { BaseState } from '../base/types';

const shouldFetchCharts = (state:AppState) => 
    !(state.charts.items.length > 0 || state.charts.isFetching)
    

export const fetchCharts = () => {
    return (dispatch: any,getState: any) =>  {
        if(!shouldFetchCharts(getState())) return Promise.resolve();
        dispatch(fetchChartsStartedAction());
        let state:AppState = getState();
        const headers = {Authorization: `token ${state.base.token}`};
        axios.get(`${BASE_URL}/charts/`,{headers})
        .then(res => {
          dispatch(fetchChartsSuccessAction(res.data));
        })
        .catch(err => {
          handleCache(dispatch,err);
        });

    };
};

 export function clone(obj: any) {
  if (null == obj || "object" != typeof obj) return obj;
  var copy = obj.constructor();
  for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}

export const getChart = (charts: Chart[], id: number) => {
    if(!charts || !id || id==0)  return;
    let chart :Chart = clone({});
    charts.map( (item:Chart,i:number) => {
        if (item.id === id) chart = clone(item);
    });
    if(!chart) return;
    let allNodes = chart.nodes;
    delete chart.nodes;

    chart.nodes = treeToArr(chart.parent_nodes, allNodes);

    return chart;
}

const treeToArr = (parents :number[], tree:any) => {
    if(!parents || !tree) return [];
    let res:any = parents.map(parent => {
        let curr_obj = tree[parent.toString()];
        let tmpChildren = [];
        if(!curr_obj) return;
        if(curr_obj.children.length > 0)
            tmpChildren = treeToArr(curr_obj.children, tree);
        return Object.assign({}, curr_obj, {
            children: tmpChildren
        })
    })
    return res;
}